export default "__VITE_ASSET__2775133d__"